var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-Echarts-CustomGauge"},[_c('div',{ref:"CustomGaugeMian",staticStyle:{"height":"250px"},attrs:{"id":'CustomGaugeMian'+_vm.num}})])}
var staticRenderFns = []

export { render, staticRenderFns }